import { render, staticRenderFns } from "./AdministrativeActsTable.vue?vue&type=template&id=2da694b6&scoped=true&"
import script from "./AdministrativeActsTable.vue?vue&type=script&lang=js&"
export * from "./AdministrativeActsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeActsTable.vue?vue&type=style&index=0&id=2da694b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da694b6",
  null
  
)

export default component.exports